import Vue from 'vue'
import consts from '@/consts'
import {createActionHelpers} from 'vuex-loading'
import i18n from '@/translator'

const {startLoading, endLoading} = createActionHelpers({
  moduleName: 'loading'
})

function getArtists (genreFilter, page, commit, textToFilter) {
  const promise = Vue.http.get(consts.API_BASE_URL + `/artist/ByGenre/${genreFilter}/${page}/${textToFilter}`)
  promise.then((response) => {
    if (response.data.status === 'ok') {
      // commit('incrementFrom', 1)
    }
  })
  return promise
}

const initialStates = function () {
  return {
    error: '',
    myArtistInfo: Object,
    myArtistInfoRefresh: 0,
    searchQuery: '',
    page: 0,
    artist: Object,
    artistsError: '',
    artists: [],
    noMoreResults: false,
    previousRequest: false,
    artistPlaylists: [],
    artistTracks: [],
    isProfileOpen: false,
    vinylContest: [],
    vinylContestInfo: [],
    genreFilter: 0
  }
}

const mutations = {
  setMyArtistInfo (state, value) {
    state.myArtistInfo = value

    // flag, lo uso, para cuando cargo artista, si existe o no el artista
    // fuerzo a que pase por aca, para que incremente el contador y poder
    // capturarlo con el watch
    state.myArtistInfoRefresh++
  },
  setArtist (state, value) {
    state.artist = value
  },
  setArtistGenreFilter (state, value) {
    state.genreFilter = value
  },
  setPageFrom (state, value) {
    state.page = value
  },
  previousRequest (state, payload) {
    if (state.previousRequest && state.previousRequest !== payload.request) {
      state.previousRequest.abort()
    }
    state.previousRequest = payload.request
  },
  setSearchQuery (state, value) {
    state.page = 0
    state.searchQuery = value
    state.artists = []
    state.noMoreResults = false
  },
  setAll (state, value) {
    state.artists = value
  },
  error (state, value) {
    state.error = value
  },
  appendPage (state, value) {
    state.artists.push(...value)
    state.page++
  },
  noMoreResults (state, value) {
    state.noMoreResults = value
  },
  setArtistPlaylists (state, value) {
    state.artistPlaylists = value
  },
  updatePrimaryPicture (state, value) {
    state.myArtistInfo.path = value.path
    state.myArtistInfo.primary_picture = value.filename
  },
  setTracks (state, value) {
    state.artistTracks = value
  },
  isProfileOpen (state, value) {
    state.isProfileOpen = value
  },
  setVinylContest (state, artists, info) {
    state.vinylContest = artists
    state.vinylContestInfo = info
  },
  resetError (state) {
    state.error = ''
  }
}

const actions = {

  getMyArtistInfo ({ commit, dispatch }) {
    startLoading(dispatch, 'artist getMyArtistInfo')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/artists/getMyData').then(
        function (res) {
          endLoading(dispatch, 'artist getMyArtistInfo')
          if (res.body.status === 'ok') {
            commit('setMyArtistInfo', res.body.data)
            resolve()
          } else {
            // force, hago que si o si, pase por el state myArtistInfo
            commit('setMyArtistInfo', res.body.data)
            commit('error', i18n.t('error.store.data'))
            reject(new Error(i18n.t('error.store.data')))
          }
        },
        function () {
          endLoading(dispatch, 'artist getMyArtistInfo')
          commit('error', i18n.t('error.store.network'))
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  editArtist ({ commit, dispatch }, artist) {
    startLoading(dispatch, 'artist editArtist')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/artists/editGeneral', {
        name: artist.name,
        phrase: artist.phrase,
        text: artist.text
      }).then(
        function (response) {
          endLoading(dispatch, 'artist editArtist')
          if (response.body.status === 'ok' && response.body.data === 'saved') {
            resolve()
          } else {
            if (response.body.status === 'error') {
              switch (response.body.error) {
                case 'fail: no data posted': {
                  commit('error', {
                    message: i18n.t('error.store.noDataPosted')
                  })
                  break
                }
                case 'not valid token': {
                  commit('error', {
                    message: i18n.t('error.store.notValidToken')
                  })
                  break
                }
                case 'fail: not saved': {
                  commit('error', {
                    message: i18n.t('error.store.notSaved')
                  })
                  break
                }
                default: {
                  commit('error', {
                    message: i18n.t('error.store.editArtist')
                  })
                  break
                }
              }
            }
            reject(new Error(response.body.error))
          }
        },
        function () {
          endLoading(dispatch, 'artist editArtist')
          commit('error', {
            error: true,
            message: i18n.t('error.store.network')
          })
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  getArtist ({ commit, dispatch }, id) {
    startLoading(dispatch, 'artist getArtist')
    dispatch('resetArtist')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/artists/get/' + id).then(
        function (res) {
          endLoading(dispatch, 'artist getArtist')
          if (res.body.status === 'ok') {
            commit('setArtist', res.body.data)
            resolve()
          } else {
            commit('error', i18n.t('error.store.data'))
            reject(new Error(i18n.t('error.store.data')))
          }
        },
        function () {
          endLoading(dispatch, 'artist getArtist')
          commit('error', i18n.t('error.store.network'))
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  resetArtist ({ commit }) {
    commit('setArtist', {})
    commit('setArtistPlaylists', [])
    commit('setTracks', [])
  },

  resetError ({ commit }) {
    commit('resetError')
  },

  loadMoreArtists ({ commit, state, dispatch }, textToFilter = null) {
    startLoading(dispatch, 'artist loadMore')
    return new Promise((resolve, reject) => {
      getArtists(state.genreFilter, state.page, commit, textToFilter)
        .then(
          function (response) {
            commit('previousRequest', false)
            if (response.status === 200) {
              if (response.body.data.length > 0) {
                commit('appendPage', response.body.data)
                commit('noMoreResults', false)
              } else {
                commit('noMoreResults', true)
              }
              endLoading(dispatch, 'artist loadMore')
              resolve(response.body.data)
            } else {
              commit('error', { error: true, message: i18n.t('error.store.artists') })
              endLoading(dispatch, 'artist loadMore')
              reject(new Error(i18n.t('error.store.artists')))
            }
          },
          function () {
            commit('previousRequest', false)
            endLoading(dispatch, 'artist loadMore')
            commit('error', { error: true, message: i18n.t('error.store.network') })
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  getAllArtists ({commit, dispatch, state}, textToFilter = null) {
    startLoading(dispatch, 'artist getAll')
    commit('noMoreResults', false)
    return new Promise((resolve, reject) => {
      getArtists(state.genreFilter, state.page, commit, textToFilter)
        .then(
          function (response) {
            endLoading(dispatch, 'artist getAll')
            if (response.body.status === true) {
              commit('setAll', response.body.data)
              commit('setPageFrom', 1)
              resolve(response.body.data)
            } else {
              commit('setAll', null)
              commit('error', {error: true, message: i18n.t('error.store.artists')})
              reject(new Error(i18n.t('error.store.network')))
            }
          },
          function () {
            endLoading(dispatch, 'artist getAll')
            commit('error', {error: true, message: i18n.t('error.store.network')})
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  setArtistGenreFilter ({commit}, value) {
    commit('setArtistGenreFilter', value)
  },

  resetResults ({ commit }) {
    commit('setFilterResults', [])
  },

  filter ({ commit, dispatch }, payload) {
    startLoading(dispatch, 'artist setFilterResults')
    /**
     * Temporary hack to avoid going to network with a blank query and
     * assuring than normal list results are displayed immediately.
     */
    if (payload.query === '') {
      endLoading(dispatch, 'artist setFilterResults')
      commit('setFilterResults', [])
    }

    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/artists/getAll')
        .then(
          function (response) {
            endLoading(dispatch, 'artist setFilterResults')
            if (response.body.status === 'ok') {
              commit('setFilterResults', response.body.data.filter(artist => artist.name && artist.name.search(payload.query) !== -1))
              resolve(response.data.data)
            } else {
              commit('error', { error: true, message: i18n.t('error.store.artists') })
              reject(new Error(i18n.t('error.store.artists')))
            }
          },
          function () {
            endLoading(dispatch, 'artist setFilterResults')
            commit('error', { error: true, message: i18n.t('error.store.network') })
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  setPageFrom ({ commit }, value) {
    commit('setPageFrom', value)
  },

  getArtistPlaylists ({ commit, dispatch }, id) {
    startLoading(dispatch, 'artist getArtistPlaylists')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/artist/' + id + '/playlists').then(
        function (response) {
          endLoading(dispatch, 'artist getArtistPlaylists')
          if (response.body.status) {
            commit('setArtistPlaylists', response.body.data)
            resolve()
          } else {
            commit('error', { error: true, message: i18n.t('error.store.playlists') })
            reject(new Error(i18n.t('error.store.playlists')))
          }
        },
        function () {
          endLoading(dispatch, 'artist getArtistPlaylists')
          commit('error', { error: true, message: i18n.t('error.store.network') })
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  updatePrimaryPicture ({ commit }, value) {
    commit('updatePrimaryPicture', value)
  },

  getArtistTracks ({ commit, dispatch }, id) {
    startLoading(dispatch, 'artist getArtistTracks')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/tracks/getArtistTracks/' + id).then(
        function (response) {
          endLoading(dispatch, 'artist getArtistTracks')
          if (response.body.status === 'ok') {
            commit('setTracks', response.body.data[0].sort((a, b) => {
              if (parseInt(a.order_position) > parseInt(b.order_position)) {
                return 1
              }
              if (parseInt(a.order_position) < parseInt(b.order_position)) {
                return -1
              }
              return 0
            }))
            resolve()
          } else {
            commit('error', { error: true, message: i18n.t('error.store.tracks') })
            reject(new Error(i18n.t('error.store.tracks')))
          }
        },
        function () {
          endLoading(dispatch, 'artist getArtistTracks')
          commit('error', { error: true, message: i18n.t('error.store.network') })
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  setVote ({ commit, state, dispatch }, id) {
    startLoading(dispatch, 'artist setVote')
    return new Promise((resolve, reject) => {
      if (state.artistTracks.length > 0) {
        Vue.http.post(consts.API_BASE_URL + '/tracks/setVote/', {
          track_id: state.artistTracks[0].id
        }).then(
          function (response) {
            endLoading(dispatch, 'artist setVote')
            if (response.body.status === 'ok') {
              if (response.body.data === 'voted') {
                commit('user/decreaseMyVotes', null, { root: true })
                resolve()
              }
            } else {
              if (response.body.error === 'Already use vote quote') {
                commit('error', {
                  error: true,
                  message: i18n.t('error.store.voteQuote')
                })
                reject(new Error(i18n.t('error.store.voteQuote')))
              } else if (response.body.error === 'SameArtistAndUser') {
                commit('error', {
                  error: true,
                  message: i18n.t('error.store.SameArtistAndUser')
                })
                reject(new Error(i18n.t('error.store.SameArtistAndUser')))
              } else {
                commit('error', { error: true, message: i18n.t('error.store.vote') })
                reject(new Error(i18n.t('error.store.vote')))
              }
            }
          },
          function () {
            endLoading(dispatch, 'artist setVote')
            commit('error', { error: true, message: i18n.t('error.store.network') })
            reject(new Error(i18n.t('error.store.network')))
          })
      } else {
        endLoading(dispatch, 'artist setVote')
        commit('error', { error: true, message: i18n.t('artists.hasNotTracks') })
        reject(new Error(i18n.t('artists.hasNotTracks')))
      }
    })
  },

  getVinylContest ({ commit, dispatch }) {
    startLoading(dispatch, 'artist getVinylContest')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/tracks/getContest').then(
        function (response) {
          endLoading(dispatch, 'artist getVinylContest')
          if (response.body.status === 'ok') {
            if (response.body.data['cant'] > 0) {
              commit('setVinylContest', response.body.data.data, response.body.data)
              resolve()
            }
          } else {
            commit('error', { error: true, message: i18n.t('error.store.vinylContest') })
            reject(new Error(i18n.t('error.store.vinylContest')))
          }
        },
        function () {
          endLoading(dispatch, 'artist getVinylContest')
          commit('error', { error: true, message: i18n.t('error.store.network') })
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  openProfile ({ commit }) {
    commit('isProfileOpen', true)
  },

  closeProfile ({ commit }) {
    commit('isProfileOpen', false)
  },

  contact ({ commit, dispatch }, value) {
    startLoading(dispatch, 'artist contact')
    return Vue.http.post(consts.API_BASE_URL + '/artist/' + value.artist_id + '/contact', {
      message: value.message, userEmail: value.userEmail, userFirstName: value.userFirstName, userLastName: value.userLastName, username: value.username
    }).then((response) => {
      endLoading(dispatch, 'artist setComment')
      if (response.body.status) {
        return Promise.resolve()
      } else {
        return Promise.reject(new Error(i18n.t('error.store.contact')))
      }
    }).catch((e) => {
      endLoading(dispatch, 'artist setComment')
      return Promise.reject(new Error(i18n.t('error.store.network')))
    })
  },

  getPaymentInfo ({dispatch}) {
    startLoading(dispatch, 'artist getPaymentInfo')
    return Vue.http.get(consts.API_BASE_URL + '/payment/mp/userInfo').then((response) => {
      if (response.body.status) {
        endLoading(dispatch, 'artist getPaymentInfo')
        return Promise.resolve(response.body.data)
      } else {
        return Promise.reject(new Error(response.body.error.message))
      }
    }).catch((e) => {
      endLoading(dispatch, 'artist getPaymentInfo')
      return Promise.reject(new Error(e.message ? e.message : i18n.t('error.store.network')))
    })
  },

  mpConnect ({dispatch}) {
    startLoading(dispatch, 'artist mpConnect')
    return Vue.http.get(consts.API_BASE_URL + '/payment/mp/connect').then((response) => {
      if (response.body.status) {
        endLoading(dispatch, 'artist mpConnect')
        return Promise.resolve(response.body)
      } else {
        return Promise.reject(new Error(response.body.error.message))
      }
    }).catch((e) => {
      endLoading(dispatch, 'artist mpConnect')
      return Promise.reject(new Error(e.message ? e.message : i18n.t('error.store.network')))
    })
  },

  setArtisticName ({dispatch}, artisticName) {
    startLoading(dispatch, 'artist setArtisticName')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/artist/editOrCreate', artisticName).then((response) => {
        if (response.body.status !== true) {
          endLoading(dispatch, 'artist setArtisticName')
          reject(new Error(response.body.error))
        } else {
          endLoading(dispatch, 'artist setArtisticName')
          resolve()
        }
      }).catch((e) => {
        endLoading(dispatch, 'artist setArtisticName')
        return Promise.reject(new Error(e.message ? e.message : 'error setArtisticName'))
      })
    })
  }
}

const getters = {
  error: state => {
    return state.error
  },
  loading: state => {
    return state.loading
  },
  artist: state => {
    return state.artist
  },
  myArtistInfo: state => {
    return state.myArtistInfo
  },
  myArtistInfoRefresh: state => {
    return state.myArtistInfoRefresh
  },
  noMoreResults: state => {
    return state.noMoreResults
  },
  artists: state => {
    return state.artists
  },
  results: state => {
    return state.results
  },
  loadingFilterResults: state => {
    return state.loadingFilterResults
  },
  artistPlaylists: state => {
    return state.artistPlaylists
  },
  artistTracks: state => {
    return state.artistTracks
  },
  isProfileOpen: state => {
    return state.isProfileOpen
  },
  vinylContest: state => {
    return state.vinylContest
  },
  vinylContestInfo: state => {
    return state.vinylContestInfo
  },
  genreFilter: state => {
    return state.genreFilter
  },
  page: state => {
    return state.page
  }
}

const artist = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations,
  actions,
  getters
}

export default artist



// WEBPACK FOOTER //
// ./src/store/modules/artist.js